import { Calendario, Dashboard, Progreso } from '../../pages/inicio/models/dashboard.type'
import { keysToSnake } from '../../utils/ObjetosUtil'
import { baseApi } from './base.api'

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    /**
     * Recupera los indicadores generales usados en la pantalla de inicio.
     */
    recuperarDatosInicio: builder.query<Dashboard, void>({
      query: (datosInicio) => {
        return {
          url: `${window._env_.API_CONTEXTO_DASHBOARD}`,
          method: 'GET',
          body: keysToSnake(datosInicio),
        }
      },
    }),

    /**
     * Obtiene progreso mensual de autorizaciones y tareas, filtrable por sitio.
     */
    recuperarAutorizacionesTareasNacionalSitio: builder.query<
      Progreso,
      { mes: number; idSitio?: string }
    >({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_DASHBOARD}/progreso`,
          params: keysToSnake(arg),
        }
      },
    }),

    /**
     * Alimenta el calendario semanal del dashboard con tareas por fecha y estatus.
     */
    recuperarTareasPorDia: builder.query<
    Calendario,
    { fecha: string; estatusFecha: string }
  >({
    query: (arg) => {
      return {
        url: `${window._env_.API_CONTEXTO_DASHBOARD}/calendario_semanal`,
        params: keysToSnake(arg),
      }
    },
  })
    
  }),
})

export const {
  useRecuperarDatosInicioQuery,
  useRecuperarAutorizacionesTareasNacionalSitioQuery,
  useRecuperarTareasPorDiaQuery,
  useLazyRecuperarTareasPorDiaQuery,
} = dashboardApi
